import {
  QueueSessionDeliveredEvent,
  QueueSessionJoinedEvent,
  QueueSessionLeftEvent,
} from '@servicetitan/telecom-rtcs-client';
import ServiceQueue from '../../types/ServiceQueue';
import { queueSessionSyncManager } from '../../lib/QueueSessionSyncManager';
import featureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';

function setQueueStatus(
  queue: ServiceQueue,
  event:
    | QueueSessionJoinedEvent
    | QueueSessionDeliveredEvent
    | QueueSessionLeftEvent,
) {
  // check if event is QueueSessionLeftEvent or QueueSessionJoinedEvent
  const isQueueSessionDeliveredOrJoinedEvent =
    event.type === 'queue.sessionJoined' ||
    event.type === 'queue.sessionDelivered';

  queue.status.abandonedSessions = event.stats.abandonedSessions;
  queue.status.activeSessionCount = event.stats.activeSessions;
  queue.status.averageWait = event.stats.averageWaitMs;
  queue.status.longestWait = event.stats.longestWaitMs;
  queue.status.missedSessions = event.stats.missedSessions;
  queue.status.recipientCount = event.stats.agents;
  queue.status.totalSessions = event.stats.totalSessions;

  // save the estimated wait time for 'delivered' event
  // suggested by Kazoo to do this only in 'delivered'
  // and 'join' events. this value is recalculated on these events
  // CCP-3456: Default estimated wait time to historical values from other events if its not been set yet
  if (
    isQueueSessionDeliveredOrJoinedEvent ||
    queue.status.estimatedWait === undefined
  ) {
    queue.status.estimatedWait = event.stats.estimatedWaitMs;
  }

  // Check for session count mismatch and enqueue for sync if needed (only if LWT feature is enabled)
  if (
    featureFlagModule.isEnabled(FeatureFlagKeys.featureShowQueueLongestWaitTime)
  ) {
    queueSessionSyncManager.checkAndEnqueue(
      queue.id,
      event.stats.activeSessions,
      queue.sessions.length,
    );
  }
}

export default setQueueStatus;
